import type {SearchEngine} from '../../app/search-engine/search-engine.js';
import {executeSearch} from '../../features/search/search-actions.js';
import type {SortCriterion} from '../../features/sort-criteria/criteria.js';
import {
  logResultsSort,
  resultsSort,
} from '../../features/sort-criteria/sort-criteria-analytics-actions.js';
import {
  buildCoreSort,
  type Sort,
  type SortInitialState,
  type SortProps,
  type SortState,
} from '../core/sort/headless-core-sort.js';

export type {Sort, SortInitialState, SortProps, SortState};

/**
 * Creates a `Sort` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Sort` controller properties.
 * @returns A `Sort` controller instance.
 *
 * Example: [sort.tsx](https://github.com/coveo/ui-kit/blob/main/samples/headless/search-react/src/components/sort.tsx)
 *
 * @group Controllers
 * @category Sort
 */
export function buildSort(engine: SearchEngine, props: SortProps = {}): Sort {
  const {dispatch} = engine;
  const sort = buildCoreSort(engine, props);
  const search = () =>
    dispatch(
      executeSearch({
        legacy: logResultsSort(),
        next: resultsSort(),
      })
    );

  return {
    ...sort,

    get state() {
      return sort.state;
    },

    sortBy(criterion: SortCriterion | SortCriterion[]) {
      sort.sortBy(criterion);
      search();
    },
  };
}
